import { useQuery } from "@apollo/client";
import { uniqBy } from "lodash";
import { Suspense, useMemo } from "react";

import isNotNullish from "lib/isNotNullish";
import Suspender from "lib/Suspender";
import { WorkspaceCurrenciesDoc } from "operations";

import { LoadingSkeleton } from "@joor/design-system";
import { StyledContent, StyledLabel, StyledTitle } from "./styledComponents";

const useColorCount = (workspaceId: string, isBrand: boolean) => {
  const { data, loading } = useQuery(WorkspaceCurrenciesDoc, {
    variables: { workspaceId },
  });
  const currencies = useMemo(
    () =>
      uniqBy(
        data?.retailWorkspace?.assortments
          ?.flatMap((a) =>
            a.financialOverview.financialDetails
              ?.filter((c) =>
                isBrand ? c.isBrandCurrency : !c.isBrandCurrency
              )
              .map((c) => c.currencyCode)
          )
          .filter(isNotNullish),
        (currencies) => currencies
      ),
    [data?.retailWorkspace?.assortments, isBrand]
  );
  return { loading, currencies };
};

export const Currencies = ({
  workspaceId,
  moreCurrencies,
  isBrand,
}: {
  workspaceId: string;
  moreCurrencies: boolean;
  isBrand: boolean;
}) => {
  const { loading, currencies } = useColorCount(workspaceId, isBrand);
  const listCurrencies = currencies.map((cur) => (
    <StyledTitle data-testid="currency-value">{cur}</StyledTitle>
  ));
  return (
    <StyledContent>
      <StyledLabel>Currency</StyledLabel>
      <Suspense fallback={<LoadingSkeleton />}>
        <Suspender suspend={loading}>
          {moreCurrencies ? (
            listCurrencies
          ) : (
            <StyledTitle data-testid="currency-value">
              {currencies[0] ?? "-"}
            </StyledTitle>
          )}
        </Suspender>
      </Suspense>
    </StyledContent>
  );
};
